import {
  SET_PASSPORT_FEE,
  SET_PASSPORT_AMOUNT,
  SET_PASSPORT_ASSET_VIEW,
} from '../types';

export function setAssetView(view){
  return function(dispatch) {
    dispatch({
      type: SET_PASSPORT_ASSET_VIEW,
      payload:view
    });
  }
}

export function setAmount(view) {
  return function(dispatch) {
    dispatch({
      type: SET_PASSPORT_AMOUNT,
      payload:view
    });
  }
}

export function setFee(fee){
  return function(dispatch) {
    dispatch({
      type: SET_PASSPORT_FEE,
      payload:fee
    });
  }
}
